export default __webpack_public_path__ + "static/media/homeIcon.fee04084.svg";